/* eslint-disable perfectionist/sort-enums */
// The order of items is used in combobox and should be numerical instead of alphabetical. So please don't change.
export enum EventEcgCardioExaminationDuration {
    sevenDays = 'sevenDays',
    fourteenDays = 'fourteenDays',
}
